/**
 * Unauthenticated public Drive viewer client (131.34). Resolves shared folders
 * and files by token. Uses a bare axios instance (no bearer, no refresh
 * interceptor) since these pages are viewed by people who are not logged in.
 */
import axios from 'axios';

const pub = axios.create({ baseURL: '/api/v1' });

export interface PubFolderRef {
  id: string;
  name: string;
}

export interface PubFileRef {
  id: string;
  name: string;
  sizeBytes: number | null;
  mimeType: string | null;
}

export interface PubFolderView {
  root: PubFolderRef;
  current: PubFolderRef;
  folders: PubFolderRef[];
  files: PubFileRef[];
}

export async function getPublicFolder(token: string, folderId?: string): Promise<PubFolderView> {
  const { data } = await pub.get<PubFolderView>(`/public/drive/folder/${encodeURIComponent(token)}`, {
    params: folderId ? { folderId } : undefined,
  });
  return data;
}

export async function getPublicFile(token: string): Promise<PubFileRef> {
  const { data } = await pub.get<PubFileRef>(`/public/drive/file/${encodeURIComponent(token)}`);
  return data;
}

// Direct content URLs (streamed by the backend with Content-Disposition). Used
// as <a href> download targets so the browser handles the download natively.
export function publicFolderFileContentURL(token: string, fileId: string): string {
  return `/api/v1/public/drive/folder/${encodeURIComponent(token)}/file/${fileId}/content`;
}

export function publicFileContentURL(token: string): string {
  return `/api/v1/public/drive/file/${encodeURIComponent(token)}/content`;
}
